import { VehicleCollection } from "@/components/booking/create/VehicleCollection";
import React from "react";

export default function Step3Screen() {
  return <VehicleCollection />;
}
